"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var draftail_1 = require("draftail");
var Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
var Portal_1 = __importDefault(require("../../Portal/Portal"));
var shortenLabel = function (label) {
    var shortened = label;
    if (shortened.length > 25) {
        shortened = shortened.slice(0, 20) + "\u2026";
    }
    return shortened;
};
var TooltipEntity = /** @class */ (function (_super) {
    __extends(TooltipEntity, _super);
    function TooltipEntity(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showTooltipAt: null,
        };
        _this.onEdit = _this.onEdit.bind(_this);
        _this.onRemove = _this.onRemove.bind(_this);
        _this.openTooltip = _this.openTooltip.bind(_this);
        _this.closeTooltip = _this.closeTooltip.bind(_this);
        return _this;
    }
    TooltipEntity.prototype.onEdit = function (e) {
        var _a = this.props, onEdit = _a.onEdit, entityKey = _a.entityKey;
        e.preventDefault();
        e.stopPropagation();
        onEdit(entityKey);
    };
    TooltipEntity.prototype.onRemove = function (e) {
        var _a = this.props, onRemove = _a.onRemove, entityKey = _a.entityKey;
        e.preventDefault();
        e.stopPropagation();
        onRemove(entityKey);
    };
    TooltipEntity.prototype.openTooltip = function (e) {
        var trigger = e.target.closest('[data-draftail-trigger]');
        // Click is within the tooltip.
        if (!trigger) {
            return;
        }
        var container = trigger.closest('[data-draftail-editor-wrapper]');
        var containerRect = container.getBoundingClientRect();
        var rect = trigger.getBoundingClientRect();
        this.setState({
            showTooltipAt: {
                container: container,
                top: rect.top - containerRect.top - (document.documentElement.scrollTop || document.body.scrollTop),
                left: rect.left - containerRect.left - (document.documentElement.scrollLeft || document.body.scrollLeft),
                width: rect.width,
                height: rect.height,
            },
        });
    };
    TooltipEntity.prototype.closeTooltip = function () {
        this.setState({ showTooltipAt: null });
    };
    TooltipEntity.prototype.render = function () {
        var _a = this.props, children = _a.children, icon = _a.icon, label = _a.label, url = _a.url;
        var showTooltipAt = this.state.showTooltipAt;
        return (react_1["default"].createElement("a", { href: url, role: "button", 
            // Use onMouseUp to preserve focus in the text even after clicking.
            onMouseUp: this.openTooltip, className: "TooltipEntity", "data-draftail-trigger": true },
            react_1["default"].createElement(draftail_1.Icon, { icon: icon, className: "TooltipEntity__icon" }),
            children,
            showTooltipAt && (react_1["default"].createElement(Portal_1["default"], { node: showTooltipAt.container, onClose: this.closeTooltip, closeOnClick: true, closeOnType: true, closeOnResize: true },
                react_1["default"].createElement(Tooltip_1["default"], { target: showTooltipAt, direction: "top" },
                    label ? (react_1["default"].createElement("a", { href: url, title: url, target: "_blank", rel: "noopener noreferrer", className: "Tooltip__link" }, shortenLabel(label))) : null,
                    react_1["default"].createElement("button", { className: "button Tooltip__button", onClick: this.onEdit }, "Edit"),
                    react_1["default"].createElement("button", { className: "button button-secondary no Tooltip__button", onClick: this.onRemove }, "Remove"))))));
    };
    return TooltipEntity;
}(react_1.Component));
TooltipEntity.propTypes = {
    entityKey: prop_types_1["default"].string.isRequired,
    children: prop_types_1["default"].node.isRequired,
    onEdit: prop_types_1["default"].func.isRequired,
    onRemove: prop_types_1["default"].func.isRequired,
    icon: prop_types_1["default"].oneOfType([
        prop_types_1["default"].string.isRequired,
        prop_types_1["default"].object.isRequired,
    ]).isRequired,
    label: prop_types_1["default"].string.isRequired,
    url: prop_types_1["default"].string,
};
TooltipEntity.defaultProps = {
    url: null,
};
exports["default"] = TooltipEntity;
